export default __webpack_public_path__ + "static/media/batteryCharge.a58441ac.svg";